module.exports = __webpack_public_path__ + "img/Hunan-power.6cd947a4.png";